import { Form } from "@remix-run/react";
import { Trans, useTranslation } from "react-i18next";
import IconLock from "~/assets/icons/lock.svg";
import { Button } from "~/components/Button";
import { InputWithLabel } from "~/components/Input";
import { Link } from "~/components/Link";
import { ExternalLink } from "~/components/Link/ExternalLink";
import { BodyMedium } from "~/components/Typography";

export const EmailPasswordForm: React.FC<{
  isLoading: boolean;
  error?: string;
}> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <header className="mb-3 text-[40px] font-bold leading-[52px] text-[#072236]">
        {t("webapp.login.title", "Sign in")}
      </header>
      <BodyMedium className="mb-2 font-semibold text-gray-600">
        {t("webapp.login.description", "Welcome back to Finblox!")}
      </BodyMedium>
      <div className="text-[14px] font-semibold leading-[22px] text-gray-400">
        {t("webapp.login.heading", "Don’t have account?")}{" "}
        <Link to="/signup" variants="primary">
          {t("webapp.signup", "Sign up")}
        </Link>
      </div>
      <Form className="mt-4 flex flex-col gap-5" method="post">
        <input type="hidden" name="step" defaultValue="email_password" />
        <InputWithLabel
          id="email"
          label={t("webapp.email", "Email")}
          autoFocus
          type="email"
          name="email"
          autoComplete="username"
          placeholder="johndoe@gmail.com"
          required
        />
        <InputWithLabel
          id="password"
          label={t("webapp.password", "Password")}
          type="password"
          name="password"
          autoComplete="current-password"
          minLength={6}
          maxLength={32}
          required
        />
        {props.error && (
          <p className="typesetting-validation-error mt-[6px]">{props.error}</p>
        )}
        <div className="text-sm font-normal leading-normal text-gray-600">
          <Trans i18nKey="webapp.disclaimer_text.login">
            By tapping "Sign In", you agree to our{" "}
            <ExternalLink
              className="text-sm leading-normal"
              to="https://finblox.com/terms-of-use"
            >
              Terms of Use
            </ExternalLink>{" "}
            and confirm that you have read our{" "}
            <ExternalLink
              className="text-sm leading-normal"
              to="https://finblox.com/risk-disclosure"
            >
              Risk Disclosure
            </ExternalLink>
            ,{" "}
            <ExternalLink
              className="text-sm leading-normal"
              to="https://finblox.com/privacy-policy"
            >
              Privacy Policy
            </ExternalLink>
            , and{" "}
            <ExternalLink
              className="text-sm leading-normal"
              to="https://help.finblox.com/en/articles/6344319-important-disclaimer"
            >
              Disclaimer
            </ExternalLink>
            .
          </Trans>
        </div>
        <Button
          loading={props.isLoading}
          className="flex items-center justify-center"
        >
          <img alt="" src={IconLock} className="mr-3 h-4 w-4" />
          {t("webapp.signin", "Sign In")}
        </Button>
        <Link to="/forgot-password">
          {t("webapp.login.link_to_forgot_password", "Forgot Password?")}
        </Link>
      </Form>
    </div>
  );
};
